import PartsManager from "../../pages/report/parts";
import { PartsDetailsPage } from "../../pages/report/parts/PartsDetailsPage";

export const routePartsManager = "/parts-manager";

export const reportRoutes = [
	{
		path: routePartsManager,
		element: <PartsManager />,
		permission: "ui.navbar.parts",
	},
	{
		path: `${routePartsManager}/:partId`,
		element: <PartsDetailsPage />,
		permission: "ui.navbar.parts",
	},
];
